import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { DayOfWeekType, DaysOfWeek } from 'lib/daysOfWeek'
import equal from 'fast-deep-equal'
import { Spacer } from 'components/Utility'
const daysOfWeekInstance = new DaysOfWeek()

type Props = {
  daysOfWeek: DayOfWeekType[]
  holidays: DayOfWeekType[]
}

const DaysOfWeekColumn: FC<Props> = React.memo(
  (props) => {
    const { daysOfWeek, holidays } = props
    return (
      <div className={styles.businessHour__column}>
        <h3 className={styles.businessHour__column__header}>曜日</h3>
        {daysOfWeek.map((dayOfWeek) => {
          const className = (() => {
            switch (true) {
              case holidays.includes(dayOfWeek):
                return styles.businessHour__column__label_grey
              case dayOfWeek === 'sun':
                return styles.businessHour__column__label_red
              case dayOfWeek === 'sat':
                return styles.businessHour__column__label_blue
              case dayOfWeek === 'hol':
                return styles.businessHour__column__label_red
              default:
                return styles.businessHour__column__label
            }
          })()
          return (
            <React.Fragment key={dayOfWeek.toString()}>
              <Spacer size={12} />
              <div className={className}>{daysOfWeekInstance.getShortName(dayOfWeek)}</div>
            </React.Fragment>
          )
        })}
      </div>
    )
  },
  (prev, next) => equal(prev, next)
)

export default DaysOfWeekColumn
